import React from "react";

// ui importing
import StudentQuestionFormUI from "./form";

const StudentQuestionUI = () => {

  return (
    <div className="
      flex flex-col items-center w-full h-full md:p-5 p-0
    ">
      <StudentQuestionFormUI />
    </div>
  )
}

export default StudentQuestionUI;
